import { ReactNode } from 'react';
import { pickDataAttributes } from '@gafe/common-ui';
import merge from 'classnames';

import styles from './OrderBlockWrapper.module.scss';

export type OrderBlockWrapperProps = {
  children: ReactNode;
  color?: string;
  className?: string;
};

export const OrderBlockWrapper = (props: OrderBlockWrapperProps) => {
  const color = props.color ? { background: props.color } : {};

  return (
    <div
      className={merge(styles.order_block_wrapper, props.className)}
      style={color}
      {...pickDataAttributes(props)}
    >
      {props.children}
    </div>
  );
};
